import { getHref } from '../static/js/business'
// svip 过期弹窗的领券链接
export var hebei = {
  platformConst_svipEndCoupon_mj_40_stockId: '1219620000000506',
  platformConst_svipEndCoupon_mj_40: getHref('busifavorReecive')({
    stockId: '1219620000000506'
  })
}
export var shanxi = {
  platformConst_svipEndCoupon_mj_40_stockId: '1230330000000358',
  platformConst_svipEndCoupon_mj_40: getHref('busifavorReecive')({
    stockId: '1230330000000358'
  })
}
